import React from 'react';
import { useMediaQuery } from '@material-ui/core';
import { MUI_MOBILE_BREAKPOINT } from 'src/scripts/utils/constants';
import { prependLocaleToPath } from 'src/scripts/utils/localization';

const NoResultsMessage = ({ searchQuery }: { searchQuery: string }) => {
  const isMobile = useMediaQuery(MUI_MOBILE_BREAKPOINT, { noSsr: true });
  return (
    <div className={`no-results-message d-flex flex-column align-items-center ${isMobile ? '' : 'mt-xl'}`}>
      <p className="body-large">
        Sorry, we couldn't find <span className="body-large semibold">"{searchQuery}"</span>
      </p>
      <p className="body mt-m-sm">
        Need help?{' '}
        <a href={prependLocaleToPath('/pages/help-center')} className="body underline">
          Contact Us
        </a>
      </p>
    </div>
  );
};

export default NoResultsMessage;
